type getTextVariantArgs = {
  isDisabled?: boolean;
  isFocused?: boolean;
  menuIsOpen?: boolean;
  hasSelectedOption?: boolean;
  isReadOnly?: boolean;
};

export const getTextVariant = ({
  isFocused,
  menuIsOpen,
  isDisabled,
  isReadOnly,
  hasSelectedOption,
}: getTextVariantArgs) => {
  if (hasSelectedOption) {
    return "SELECTED";
  }
  if (isDisabled) {
    return "DISABLED";
  }
  if (isFocused || menuIsOpen || isReadOnly) {
    return "FOCUSED";
  }
  return "DEFAULT";
};
